<template>
  <div>
    <iframe
      :src="'https://www.v-can.cn/test?lang=' + lang"
      border="0px"
      class="iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: sessionStorage.getItem('x-lang') || 'zh'
    }
  }
}
</script>

<style lang="less">
.iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
}
</style>